import { render } from "./SurveyStatsFeasibility.vue?vue&type=template&id=135d7a6b"
import script from "./SurveyStatsFeasibility.vue?vue&type=script&lang=js"
export * from "./SurveyStatsFeasibility.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/DACY_Demo_Server/kbdemo_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__